import {
    ActionReducerMap,
    MetaReducer,
    createFeatureSelector
} from '@ngrx/store';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';

import {environment} from '../../environments/environment';

import {initStateFromLocalStorage} from './meta-reducers/init-state-from-local-storage.reducer';
import {debug} from './meta-reducers/debug.reducer';
import {AuthState} from './auth/auth.models';
import {authReducer} from './auth/auth.reducer';
import {RouterStateUrl} from './router/router.state';
import {employeeReducer} from './employee/employee.reducer';
import {EmployeeState} from './employee/employee.model';

export const reducers: ActionReducerMap<AppState> = {
    auth: authReducer,
    router: routerReducer,
    employee: employeeReducer
};

export const metaReducers: MetaReducer<AppState>[] = [
    initStateFromLocalStorage
];

if (!environment.production) {
    if (!environment.test) {
        metaReducers.unshift(debug);
    }
}

export const selectAuthState = createFeatureSelector<AppState, AuthState>('auth');
export const selectRouterState = createFeatureSelector<AppState, RouterReducerState<RouterStateUrl>>('router');
export const selectEmployeeState = createFeatureSelector<AppState, EmployeeState>('employee');

export interface AppState {
    auth: AuthState;
    router: RouterReducerState<RouterStateUrl>;
    employee: EmployeeState;
}
